import { useLayoutEffect, useState } from 'react';

export default function useCompactMapLayout(containerRef, isMobile) {
  const [compact, setCompact] = useState(false);
  useLayoutEffect(() => {
    if (isMobile || !containerRef.current) {
      setCompact(false);
      return undefined;
    }
    const container = containerRef.current;
    const update = () => {
      const { width, height } = container.getBoundingClientRect();
      setCompact(width > 0 && height > 0 && (width < 1100 || height < 600));
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(container);
    return () => observer.disconnect();
  }, [containerRef, isMobile]);
  return compact;
}
